__turbopack_context__.v({
  "component": "style-module-scss-module__0ozpma__component",
  "item": "style-module-scss-module__0ozpma__item",
  "label": "style-module-scss-module__0ozpma__label",
  "list": "style-module-scss-module__0ozpma__list",
  "title": "style-module-scss-module__0ozpma__title",
});
